<template>
  <ul class="postlist">
    <li
      @click="showPost(post.id)"
      class="postlist__item"
      v-for="post in this.posts"
      :class="'postlist__item--'+post.id"
      :key="post.id"
    >
      <PostThumbnail :id="post.id" :subtitle="post.subtitle" :title="post.title" :img="post.img" />
    </li>
  </ul>
</template>

<script>
import { bus } from "../main";
import PostThumbnail from "./PostThumbnail";
import postsData from "../singlePostsData";

export default {
  name: "PostList",
  data: function() {
    return {
      posts: postsData
    };
  },
  components: {
    PostThumbnail
  },
  methods: {
    showPost: function(postID) {
      bus.$emit("showPost", postID);
    }
  }
};
</script>

<style lang='scss'>
.postlist {
  display: grid;
  grid-template-columns: 360px 360px;

  gap: 66px;

  &__item {
    &--0 {
      .post-thumbnail__subtitle {
        width: 90%;
      }
    }
  }
}

@media (max-width: 1450px) {
  .postlist {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: $tablet) {
  .post-thumbnail {
    flex-direction: column-reverse;
    border-bottom: 0;
    &__subtitle {
      font-size: 30px;
      line-height: 1.4;
    }

    // &__background {
    //   padding-bottom: 100%;
    // }

    &__foreground {
      opacity: 1;
      position: static;
      transform: none;
      padding-bottom: 100%;
      height: 0;
      overflow: hidden;
      background-color: $primary-color;
    }

    &__title {
      margin-bottom: 25px;
    }
  }
}
</style>